import {Component} from '@angular/core'

@Component({
  selector: 'aku-dummy',
  template: ''
})
export class DummyComponent {
}
